import { useEffect } from 'react'
import {
  RouteComponentProps,
  useHistory,
  useLocation,
  withRouter,
} from 'react-router-dom'
import { LAYOUT_SECTION } from '@adalo/constants'

import { StoreState, getPrebuiltLayoutSections } from 'ducks/layoutSections'
import { PrebuiltBuilderContentPlatformTarget } from 'ducks/layoutSections/types'
import { DefaultRootState, connect, useDispatch } from 'react-redux'
import { getApp } from 'ducks/apps'
import { UserState, getCurrentUser } from 'ducks/users'
import { setTool } from 'ducks/editor/tools'

import { defaults } from 'utils/objects'
import {
  FormattedSection,
  SectionCategory,
  categorizeSections,
} from 'utils/layoutSections'

import Tab from '../Tab'
import { renderSectionOption } from './sectionHelpers'

interface Props extends RouteComponentProps {
  appId: string
  options: SectionCategory[]
}

const defaultSection: FormattedSection = {
  label: 'Section',
  secondaryTags: 'Empty,Card',
  body: defaults[LAYOUT_SECTION],
  id: '1',
  name: 'Section',
  type: 'layout-section',
  createdAt: new Date(),
  updatedAt: new Date(),
}

const SectionsTab: React.FC<Props> = ({ appId, options }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    if (location.pathname.endsWith('/add')) {
      history.push(`/apps/${appId}/screens/add/section`)
    }
  }, [history, location, appId])

  const handleSelect = (
    type: Record<string, unknown>,
    startPosition: [number, number]
  ): void => {
    if (!type) {
      return
    }

    const toolOptions = type['options']
    const toolType = LAYOUT_SECTION

    dispatch(setTool(toolType, toolOptions, startPosition))
  }

  return (
    <Tab
      key="section"
      emptyMessage="No sections found"
      options={options}
      platform="responsive"
      renderItem={(section: FormattedSection) =>
        renderSectionOption({ handleSelect, ...section })
      }
      defaultOpen={['Most Used Sections']}
      className={undefined}
    />
  )
}

const mapStateToProps = (state: DefaultRootState, { appId }: Props) => {
  const user = getCurrentUser(state as UserState)
  const adaloAdmin = user?.admin || false
  let opts
  let mobileOnly = false

  if (appId) {
    const app = getApp(state, appId)
    const { layoutMode = 'both' } = app?.webSettings || {}

    mobileOnly = layoutMode === 'mobile'
    opts = {
      platformTarget: layoutMode as PrebuiltBuilderContentPlatformTarget,
      includeUnlisted: adaloAdmin,
    }
  }

  const prebuiltLayoutSections = getPrebuiltLayoutSections(
    state as StoreState,
    opts
  )

  const categoriesMap = categorizeSections(prebuiltLayoutSections, mobileOnly)

  const options = [
    { label: 'Most Used Sections', children: [defaultSection] },
    ...Array.from(categoriesMap.values()),
  ]

  return { options }
}

export default withRouter(connect(mapStateToProps)(SectionsTab))
